module.exports = Texture;

/**
 * Single texture in the webglAtlas.
 */
function Texture(size) {
  this.canvas = window.document.createElement("canvas");
  this.ctx = this.canvas.getContext("2d");
  this.isDirty = false;
  this.canvas.width = this.canvas.height = size;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vivagraphjs/src/WebGL/texture.js
// module id = 33
// module chunks = 0